// Heutiges Datum (YYYY-MM-DD) in deutscher Zeit – unabhängig von der Geräte-Zeitzone.
export const berlinTodayIso = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());

export default berlinTodayIso;
